import { defineStore } from 'pinia';

export const usePopupStore = defineStore('popup', {
  state: () => ({
    showLoading: false,

    dialogInfo: {},
    showDialog: false,

    toastInfo: {},
    showToast: false,

    confirmDialogInfo: {},
    showConfirmDialog: false,
    resolveConfirmDialog: null,

  }),
  getters: {
    // 필요한 경우 getters 추가
  },
  actions: {
    setLoadingStatus(showLoading) {
      this.showLoading = showLoading
    },

    openDialog(dialogInfo) {
      this.dialogInfo = dialogInfo
      this.showDialog = true
    },
    closeDialog() {
      this.dialogInfo = {}
      this.showDialog = false
    },

    openToast(toastInfo) {
      this.toastInfo = toastInfo
      this.showToast = true
    },
    closeToast() {
      this.toastInfo = {}
      this.showToast = false
    },

    openConfirmDialog(confirmDialogInfo) {
      this.confirmDialogInfo = confirmDialogInfo
      this.showConfirmDialog = true

      return new Promise((resolve, reject) => {
        this.resolveConfirmDialog = resolve;
      });
    },

    closeConfirmDialog(confirmed) {
      this.confirmDialogInfo = {}
      this.showConfirmDialog = false

      if (this.resolveConfirmDialog) {
        this.resolveConfirmDialog(confirmed);
        this.resolveConfirmDialog = null;
      }
    },

  },
  persist: {
    enabled: true, // 전체 state 저장 활성화
    storage: sessionStorage, // sessionStorage 사용
  },
})
